<template>
  <div class="signup">
    <div class="header">
      <Header />
    </div>
    <router-link :to="{ name: 'home' }" class="logo">
      <img src="/img/new-logo.svg" alt="logo" />
    </router-link>
    <div class="container">
      <div class="signup-inner">
        <div class="signup-content">
          <h3>Create Account</h3>
          <p>
            Fill in your details to get started. It will only take few minutes.
          </p>
        </div>
        <div
          :class="{ errMssg: errorMssg }"
          v-if="
            errorMssg !==
            'This email is not associated with any account. Please Sign Up!'
          "
        >
          {{ errorMssg }}
        </div>
        <form class="signup-form" @submit.prevent="signUp">
          <div class="input-field">
            <label for="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="First name and last name"
              v-model="fullName"
              @blur="v$.fullName.$touch()"
              @focus="v$.fullName.$reset()"
              :class="{ err: v$.fullName.$error }"
            />
            <small class="refer-surname"
              ><p class="mdi mdi-alert-circle-outline warning"></p>
              Your last name is your surname</small
            >
            <small
              :class="{ 'err-mssg': v$.fullName.$error }"
              v-if="v$.fullName.$error"
            >
              {{ v$.fullName.$errors[0].$message }}</small
            >
          </div>
          <div class="input-field">
            <label for="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              placeholder="Type in your username"
              v-model="userName"
              @blur="v$.userName.$touch()"
              @focus="v$.userName.$reset()"
              :class="{ err: v$.userName.$error }"
            />
            <small
              :class="{ 'err-mssg': v$.userName.$error }"
              v-if="v$.userName.$error"
              >Username is required</small
            >
          </div>
          <div class="input-field">
            <label for="mail">Email Address</label>
            <input
              type="mail"
              id="mail"
              name="mail"
              placeholder="example@gmail.com"
              v-model="email"
              @blur="v$.email.$touch()"
              @focus="v$.email.$reset()"
              :class="{ err: v$.email.$error }"
            />
            <small
              :class="{ 'err-mssg': v$.email.$error }"
              v-if="v$.email.$error"
              >Please provide a valid email</small
            >
          </div>
          <div class="input-field">
            <label for="number">Phone Number</label>
            <div class="number">
              <input
                type="tel"
                id="phone"
                name="phone"
                v-model="phoneNumber"
                @blur="v$.phoneNumber.$touch()"
                @focus="v$.phoneNumber.$reset()"
                :class="{ err: v$.phoneNumber.$error }"
              />
              <small
                :class="{ 'err-mssg': v$.phoneNumber.$error }"
                v-if="v$.phoneNumber.$error"
                >Please provide a valid number</small
              >
              <span>+234</span>
            </div>
          </div>
          <div class="input-field">
            <label for="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="Input password"
              v-model="password"
              @blur="v$.password.$touch()"
              @focus="v$.password.$reset()"
              :class="{ err: v$.password.$error }"
            />
            <small
              :class="{ 'err-mssg': v$.password.$error }"
              v-if="v$.password.$error"
              >Minimum of 8 characters is required</small
            >
          </div>
          <div class="input-field">
            <label for="password-two">Confirm Password</label>
            <input
              type="password"
              id="password-two"
              name="password"
              placeholder="Input password"
              v-model="sameAsPassword"
              @blur="v$.sameAsPassword.$touch()"
              @focus="v$.sameAsPassword.$reset()"
              :class="{ err: v$.sameAsPassword.$error }"
            />
            <small
              :class="{ 'err-mssg': v$.sameAsPassword.$error }"
              v-if="v$.sameAsPassword.$error"
              >Please confirm your password</small
            >
          </div>
          <div class="input-field">
            <label for="referral">Referral Code (Optional)</label>
            <input
              type="text"
              id="referral"
              name="referral"
              placeholder="Enter referral code"
              v-model="referedBy"
              :disabled="this.$route.query.refuser"
            />
            <!-- <small class="refer">*Optional</small> -->
          </div>
          <div class="aside">
            <p>
              By clicking the "Create Account" button below, you agree to our
              <router-link to="/terms-of-use">Terms of Use</router-link> and
              <router-link to="/policy">Privacy Policy</router-link>.
            </p>
          </div>
          <input type="submit" class="btn" value="Create Account" />
          <div class="have-account">
            <p>
              Have an account?
              <a
                href="https://play.google.com/store/apps/details?id=com.easyflipMobile"
                >Continue on mobile app</a
              >
            </p>
          </div>
        </form>
      </div>
    </div>
    <!-- <confirm-mail :email="email" v-show="showAuthModal" /> -->
    <!-- <SuccessMail v-show="showAuthModal" /> -->
    <!-- v-show="showAuthModal" -->
  </div>
</template>
<script>
import Header from "@/components/navbar/Header.vue";
// import ConfirmMail from "@/components/mailing/ConfirmMail.vue";
// import SuccessMail from "@/components/mailing/SuccessMail.vue";
import useVuelidate from "@vuelidate/core";
import {
  required,
  email,
  minLength,
  maxLength,
  sameAs,
  helpers,
} from "@vuelidate/validators";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "SignUp",
  setup: () => ({ v$: useVuelidate() }),
  components: {
    Header,
    // ConfirmMail,
    // SuccessMail,
  },
  data() {
    return {
      fullName: "",
      userName: "",
      email: "",
      phoneNumber: "",
      password: "",
      sameAsPassword: "",
      referedBy: "",
    };
  },
  validations() {
    const fullNameHasTwoWords = helpers.withMessage(
      "Please enter both first and last names",
      (value) => {
        if (!value) return false;
        return value.trim().split(" ").length >= 2;
      }
    );
    const requiredFullName = helpers.withMessage(
      "Full name is required",
      required
    );
    return {
      fullName: { required: requiredFullName, fullNameHasTwoWords },
      userName: { required },
      email: { required, email },
      phoneNumber: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(11),
      },
      password: { required, minLength: minLength(8) },
      sameAsPassword: {
        required,
        minLength: minLength(8),
        sameAs: sameAs(this.password),
      },
    };
  },
  methods: {
    ...mapActions(["registerUser"]),
    async signUp() {
      if (this.v$.$invalid) {
        this.v$.$validate();
      } else {
        const converted = Number(this.phoneNumber).toString();
        let referral;
        if (this.referedBy !== "" || this.$route.query.refuser) {
          referral = this.referedBy;
        }
        try {
          await this.registerUser({
            firstName: this.fullName.split(" ")[0],
            lastName: this.fullName.split(" ")[1],
            userName: this.userName,
            email: this.email,
            phoneNumber: converted,
            countryCode: "234",
            referedBy: referral,
            type: "user",
            password: this.password,
          });
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
  computed: {
    ...mapGetters(["errorMssg"]),
  },
  mounted() {
    this.$route.query.refuser
      ? (this.referedBy = this.$route.query.refuser)
      : (this.referedBy = "");
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/global.scss";
.signup {
  background: #f4f4ff;
  padding: 3rem 0;
  & .container {
    margin-top: 5rem;
  }
  & img {
    width: 150px;
  }
}
.logo {
  display: none;
}
.signup-inner {
  background: $white;
  padding: 1rem;
  margin: 1rem 0.1rem;
  border: 1px solid $white;
  border-radius: 6px;
}
.signup-form {
  margin-top: 2rem;
  text-align: left;
  & .input-field input {
    display: block;
    padding: 1rem;
    border-radius: 5px;
    background: linear-gradient(0deg, #f4f4f4, #f4f4f4),
      linear-gradient(0deg, #fbfbfb, #fbfbfb);
    border: 1px solid $banner;
    width: 100%;
    margin: 1rem 0 0;
    transition: border ease 0.5s;
    font-family: "Work Sans";
  }
  & .input-field input:focus {
    border: solid 1px $sec-color;
  }
  & .input-field {
    margin-bottom: 1rem;
  }
  & .input-field input:disabled {
    background: $calc-bg;
  }
  & .input-field label {
    font-size: 16px;
    font-weight: 600;
    color: black;
  }
  & .number {
    position: relative;
    & input {
      padding: 1rem 1rem 1rem 5rem;
    }
  }
  & span {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0.8rem;
    border-right: solid 1px $calc-border;
    color: $calc-border;
  }
  & .aside {
    margin: 1rem 0 1.5rem;
    color: black;
    font-weight: 500;
    & p {
      font-size: 16px;
      line-height: 24px;
    }
  }
  & a {
    color: $sub-color;
  }
}
.signup-content {
  & p {
    color: $create-text;
    font-size: 16px;
  }
  & h3 {
    margin-bottom: 1rem;
    font-size: 25px;
    color: black;
  }
}
.refer-surname {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  .warning {
    font-size: 14px;
  }
}

input.btn {
  width: 100% !important;
  letter-spacing: normal;
  font-family: "Work Sans";
  border-radius: 8px;
}

input[type="tel"]::-webkit-outer-spin-button,
input[type="tel"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.have-account {
  & p {
    color: black;
    text-align: center;
    margin: 0.5rem 0;
    font-size: 16px;
    & a {
      font-weight: 700;
      color: $sub-color;
    }
  }
}
.err {
  border: solid 1px #fa5d5d !important;
}
.err-mssg {
  color: #fa5d5d !important;
}
small.refer {
  color: #888;
}
.errMssg {
  color: #d8000c;
  background-color: #ffd2d2;
  padding: 12px;
  animation: opacity ease 0.5s forwards;
  width: 100%;
  margin-top: 1rem;
  border-radius: 4px;
  border: solid 1px #ffd2d2;
}
@keyframes opacity {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media screen and (min-width: 700px) {
  .signup {
    & .container {
      width: 650px;
    }
    &-inner {
      padding: 2rem;
    }
    &-content h3 {
      font-weight: 600;
      font-size: 26px;
      line-height: 43px;
    }
  }
}

@media screen and (min-width: 1000px) {
  .header {
    display: none;
  }
  .logo {
    width: 90%;
    margin: auto;
    display: block;
  }
}
@media screen and (min-width: 1400px) {
  .logo {
    width: 1200px;
  }
}
</style>
